import { Box, CircularProgress, debounce, Grid2, Typography, } from '@mui/material'

import React, { useCallback, useEffect, useMemo, useState } from 'react'

import CourseHeroImage from '../assets/DigitalCoursesAsset/CourseHeroImage.jpg'




import ResponsiveNav from '../components/navigation/navigation';
import CourseHero from '../components/Hero/Hero';
import CategoriesNavbar from '../components/CategoriesNavBar/CategoriesNavbar';
import CourseCardComponent from '../components/CardComponent/CardComponent';

// import { CourseCategories } from '../data/StaticDatas';
// import CourseSubHero from '../components/SubHero/SubHero';
import MoreCourse from '../components/MoreItems/MoreItems'
import { Outlet, useLocation } from 'react-router-dom';


import { useGet } from '../hooks/useApi';
import { Toaster } from 'react-hot-toast';

export default function DigitalCourses() {
  const location = useLocation()
  const [query, setQuery] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line
  const [displayedItems, setDisplayedItems] = useState([]);
    const [addsIndex, setAddsIndex] = useState(0);
    const [category, setCategory] = useState('All Courses Categories');
    const [moreCourses, setMoreCourses] = useState([]);
    const [AddsData, setAddsData] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const handleDetails = (product) => {
      console.log("Product details:", product);
      setSelectedProduct(product);
    };
    
    // useEffect(() => {
    //   // Parse the query parameters from the URL
    //   const searchParams = new URLSearchParams(location.search);
    //   const authToken = searchParams.get("authToken");
    //   const token = localStorage.getItem('token');

  
    //   console.log("Extracted authToken:", authToken); // Debugging log
  
    //   // Ensure the authToken is non-empty and valid
    //   if (!token) {
    //     console.log("Invalid or missing authToken. Redirecting to external page...");
    //     window.location.href = "https://mydarads.com/dashboard/makeorder";
    //   }
    // }, [location.search]);
  // const [activeIndex, setActiveIndex] = useState(0);
  // const [parentColor, setParentColor] = useState('#fff');
  const { data: courses, error: coursesErr, isLoading: coursesLoader } = useGet('/api/Courses/all-courses');

  // const coursesData = courses?.data
 
  const { 
    data: categoriesData, 
    error: categoriesError, 
    isLoading: categoriesLoading 
  } = useGet('/api/CourseCategory/Categories');
//  const categoriesDataList = categoriesData
  const { 
    data: searchData, 
    // eslint-disable-next-line
    error: searchErr, 
    isLoading: searchLoader 
  } = useGet(`/api/Courses/search-course?searchTerm=${query}`);

  // Memoized derived values

  const courseItems = useMemo(() => courses?.data || [], [courses]);
  const courseCategories = useMemo(() => categoriesData?.data || [], [categoriesData]);
  const searchResults = useMemo(() => searchData?.data || [], [searchData]);
  
  console.log(courseItems)
  console.log(courseCategories)

  useEffect(() => {
    const MoreCoursesData = courseItems?.filter((item) =>
      item?.categoryName?.toLowerCase().includes(category?.name?.toLowerCase() || '')
    );
    setMoreCourses(MoreCoursesData);
  }, [category?.name, courseItems]);
  

useEffect(() => {
  const AddsMoreData = courseItems?.filter((item) =>
    item?.categoryName.toLowerCase().includes(addsIndex?.name?.toLowerCase())
  );
  setAddsData(AddsMoreData);
}, [addsIndex, courseItems]);


  // Debounced search handler
  
const debouncedSearch = useMemo(
  () => debounce((query) => setQuery(query), 300),
  []
);
  

  // Handle search input change
  const handleSearchChange = useCallback((e) => {
    const searchQuery = e.target.value.toLowerCase();
    setSearchValue(searchQuery);
    setLoading(true);
    debouncedSearch(searchQuery);
  }, [debouncedSearch]);

  useEffect(() => {
    if (!coursesLoader && courseItems.length > 0) {
      setDisplayedItems(courseItems);
    }
  }, [courseItems, coursesLoader]);
  
  // Update displayed items based on search results
  useEffect(() => {
   
    if (query === "") {
      setDisplayedItems(courseItems);
      setLoading(false);
      return;
    }

    if (searchLoader) {
      setLoading(true);
      return;
    }
    if (categoriesLoading){
      setLoading(true)
      return
    }

    if (searchData) {
      setDisplayedItems(searchResults);
      setLoading(false);
    }
  
  }, [query, searchData, searchLoader, searchResults,coursesLoader, categoriesLoading,courseItems]);


  if (coursesLoader || categoriesLoading) {
    return <CircularProgress sx={{ display: "block", margin: "20px auto" }} />;
  }

  if (coursesErr || categoriesError) {
    return <Typography color="error">Error loading Course shop data</Typography>;
  }

  

    // Handle search input change
    // const handleSearchChange = (event) => {

    //   setSearchValue(event.target.value);
    // };
  
    // Define breadcrumb items for DigitalCourses
    const breadcrumbItems = [
      { label: 'Home', link: '/' },
      { label: 'Digital Courses', link: '/product/digital-courses' },
    ];
   // State to store the index of the active item
 

   // Handle click on a badge to update the active item
  //  const handleClick = (index) => {
  //    setActiveIndex(index); // Update active index
  //    setParentColor(index !== null ? '#1E0156' : '#fff');
     
  //  };
   const isChildRoute = location.pathname !== '/product/digital-courses';



// console.log('a',a);

return (
  <>
  {!isChildRoute && (
  <Box sx={{width: '100%',padding: { xs: 4, md: 8 }, display:'flex', flexDirection:'column'}}>

    <ResponsiveNav
      breadcrumbItems={breadcrumbItems}  
      searchValue={searchValue} 
      onSearchChange={handleSearchChange}
      searchPlaceholder="Search for a digital course..."
    />
 
        <CourseHero heroImage={CourseHeroImage} heroTitle={' Explore Courses 🎓'} heroDescription={'From business to tech, find the skills to grow your career in Nigeria. Start learning today.'}/>
   
       <CategoriesNavbar title='All Courses Categories' categories={courseCategories} to="/product/digital-courses" setCategory={setCategory} giftItems={courseItems} category={category} setMoreGifts={setMoreCourses} addsIndex={addsIndex}
            setAddsIndex={setAddsIndex}/>
<Grid2 container spacing={2} sx={{ my: 4 }}>
  {loading && (
    <Box sx={{ width: '100%', padding: { xs: 4, md: 10 }, display: 'flex', flexDirection: 'column' }}>
      <CircularProgress />
    </Box>
  )}

  {!loading && query !== '' && displayedItems?.length === 0 && (
    <Box sx={{ width: '100%', textAlign: 'center', p: 3 }}>
      <Typography variant="h6" color="text.secondary">
        No courses found.
      </Typography>
    </Box>
  )}

  {!loading && query !== '' && displayedItems?.map((item, index) => (
    <Grid2 item xs={12} sm={6} md={4} key={item.id}>
      <CourseCardComponent
        title={item.courseTitle}
        description={item.courseDescription || "No description available"}
        amount={item.price}
        detailspath={`course-details/${item.courseId}`}
        imageUrl={item.courseImagePath}
        itemId={item.id}
        location={item.location}
        setSelectedProduct={setSelectedProduct}
        handleDetails={handleDetails}
      />
    </Grid2>
  ))}

  {!loading && query === '' && category === 'All Courses Categories' && courseItems?.map((item, index) => (
    <Grid2 item xs={12} sm={6} md={4} key={item.id}>
      <CourseCardComponent
        title={item.courseTitle}
        description={item.courseDescription || "No description available"}
        amount={item.price}
        detailspath={`course-details/${item.courseId}`}
        imageUrl={item.courseImagePath}
        itemId={item.id}
        location={item.location}
        setSelectedProduct={setSelectedProduct}
        handleDetails={handleDetails}
      />
    </Grid2>
  ))}
</Grid2>

    {/* <CourseSubHero/> */}
    <MoreCourse title={addsIndex.name} moreItems={AddsData}>
    </MoreCourse>
    <Toaster />
  </Box>
  )}
  <Outlet/>
  </>
)
}